import { G } from '@mobily/ts-belt';
import { get } from 'lodash';
import { ChipField, ChipFieldProps, ChoicesProps, useChoices, useRecordContext } from 'react-admin';

import { isEmpty } from '@sh4res/bo-common/utils';

export interface SelectChipFieldProps extends ChoicesProps, ChipFieldProps {
  source?: string;
  /*
   * display the raw value if no choice matches
   */
  displayRawValueIfChoiceNotFound?: boolean;
  prefix?: string;
  'data-testid'?: string;
}

export function SelectChipField(props: SelectChipFieldProps) {
  const {
    source,
    choices,
    optionValue,
    optionText,
    translateChoice,
    displayRawValueIfChoiceNotFound,
    prefix,
    emptyText,
    'data-testid': dataTestId,
    ...rest
  } = props;

  const { getChoiceText, getChoiceValue } = useChoices({
    optionText,
    optionValue,
    translateChoice,
  });

  const record = useRecordContext(props);

  if (source === undefined) {
    return null;
  }

  const value = get(record, source);

  const choice = choices?.find((choice) => getChoiceValue(choice) === value);

  let choiceText = choice ? getChoiceText(choice) : null;

  if (displayRawValueIfChoiceNotFound && G.isNullable(choiceText)) {
    choiceText = value;
  }

  if (isEmpty(choiceText, true)) {
    if (!emptyText) {
      return null;
    }
    choiceText = emptyText;
  }

  choiceText = prefix ? `${prefix} - ${choiceText as string}` : choiceText;

  return (
    <ChipField
      data-testid={dataTestId}
      {...rest}
      record={{ ...record, [source]: choiceText }}
      source={source}
    />
  );
}
